module.exports = __webpack_public_path__ + "assets/img/jr_img2.db8c90db.png";